export const allRequiredFields = {
  work: [
    {
      key: "title",
      label: "Title",
    },
    {
      key: "employer",
      label: "Employer",
    },
    {
      key: "location",
      label: "Location",
    },
    {
      key: "startDateMonth",
      label: "Start Month",
    },
    {
      key: "startDateYear",
      label: "Start Year",
    },
    {
      key: "endDateMonth",
      label: "End Month",
    },
    {
      key: "endDateYear",
      label: "End Year",
    },
  ],
  education: [
    {
      key: "school",
      label: "School",
    },
    {
      key: "location",
      label: "Location",
    },
    {
      key: "field",
      label: "Field of Study",
    },
  ],
  volunteer: [
    {
      key: "title",
      label: "Title",
    },
    {
      key: "employer",
      label: "Employer",
    },
    {
      key: "startDateMonth",
      label: "Start Month",
    },
    {
      key: "startDateYear",
      label: "Start Year",
    },
    {
      key: "endDateMonth",
      label: "End Month",
    },
    {
      key: "endDateYear",
      label: "End Year",
    },
    {
      key: "location",
      label: "Location",
    },
  ],
  leadership: [
    {
      key: "title",
      label: "Title",
    },
    {
      key: "affiliation",
      label: "Affiliation",
    },
    {
      key: "startDateMonth",
      label: "Start Month",
    },
    {
      key: "startDateYear",
      label: "Start Year",
    },
    {
      key: "endDateMonth",
      label: "End Month",
    },
    {
      key: "endDateYear",
      label: "End Year",
    },
    {
      key: "location",
      label: "Location",
    },
  ],
  award: [
    {
      key: "title",
      label: "Title",
    },
    {
      key: "issuer",
      label: "Issuer",
    },
    {
      key: "endDateMonth",
      label: "End Month",
    },
    {
      key: "endDateYear",
      label: "End Year",
    },
  ],
  life: [
    {
      key: "milestone",
      label: "Milestone",
    },
    {
      key: "description",
      label: "Description",
    },
    {
      key: "endDateMonth",
      label: "End Month",
    },
    {
      key: "endDateYear",
      label: "End Year",
    },
  ],
  certificate: [
    {
      key: "title",
      label: "Name",
    },
    {
      key: "issuer",
      label: "Issuing Organization",
    },
  ],
  coursework: [
    {
      key: "title",
      label: "Course Title",
    },
  ],
}

/**
 * Checks that an inputted start and end date are properly formatted:
 * - if a start/end date was inputted, it must have both a month and year
 * - years must be 4 digits long
 * - dates must be in the past
 * - if both a start and end date were inputted, the end date must be after the start date
 * @returns {string} an error message if the dates are invalid, or "" if the dates are valid
 */
const verifyDates = (startMonth, startYear, endMonth, endYear) => {
  if ((startMonth && !startYear) || (!startMonth && startYear)
      || (endMonth && !endYear) || (!endMonth && endYear)) {
    return "Dates must include both a month and a year\n"
  }

  for (const year of [startYear, endYear]) {
    if (year && !/^(19|20)\d{2}$/.test(year)) {
      return "Years must be formatted (YYYY)\n"
    }
  }

  let startDate = undefined
  if (startMonth && startYear) {
    startDate = new Date(startYear, startMonth)
    // Uncomment this if you want to check that the start date is in the past, doesnt allow for current month so disabled for now

    // if (Math.sign(startDate - Date.now()) === 1) {
    //   return "Start Date must be in the past\n"
    // }
  } 

  let endDate = undefined
  if (endMonth && endYear) {
    endDate = new Date(endYear, endMonth)
    // Uncomment this if you want to check that the end date is in the past, doesnt allow for current month so disabled for now

    // if (Math.sign(endDate - Date.now()) === 1) {
    //   return "End Date must be in the past\n"
    // }
  }

  if (startDate && endDate && (Math.sign(endDate - startDate) === -1)) {
    return "End Date must be after Start Date\n"
  }

  return ""
}

export const checkRequiredFields = (experience, type) => {
  let errors = []
  let requiredFields = allRequiredFields[type] || []

  // required fields for each type of experience
  requiredFields.forEach(({ key, label }) => {
    // users entry from form field
    const userEntry = experience[key]

    if (userEntry === undefined || userEntry?.length === 0) {
      errors.push(`${label}\n`)
    }
  })

  // Verify any dates
  const dateError = verifyDates(experience.startDateMonth, experience.startDateYear, experience.endDateMonth, experience.endDateYear)
  if (dateError !== "") {
    errors.push(dateError)
  }

  if (errors.length > 0) {
    return errors
  } else {
    return false
  }
}
